function StatCard({
  label,
  value,
  note = "",
  tone = "default",
  icon = "",
  trend = "",
  trendPositive = false,
  onClick = null,
  className = "",
}) {
  const interactive = typeof onClick === "function";
  const Component = interactive ? "button" : "div";

  return (
    <Component
      type={interactive ? "button" : undefined}
      className={`appStatCard is-${tone} ${interactive ? "isInteractive" : ""} ${className}`.trim()}
      onClick={onClick || undefined}
    >
      {icon ? <span className="appStatCardIcon" aria-hidden="true">{icon}</span> : null}
      <span className="appStatCardLabel">{label}</span>
      <strong className="appStatCardValue">{value}</strong>
      {note ? <p className="appStatCardNote">{note}</p> : null}
      {trend ? (
        <span className={`appStatCardTrend ${trendPositive ? "isPositive" : ""}`}>
          {trend}
        </span>
      ) : null}
    </Component>
  );
}

export default StatCard;
